import React, { useEffect, useRef, useState } from 'react';
import classes from './HeaderNav.module.css';
import logo from '../../../Assets/dshbrdlogo.png';
import icon from '../../../Assets/dshbrdicon.png';
import membericonactive from '../../../Assets/ussee.png';
import membericoninactive from '../../../Assets/usse.png';
import savingactive from '../../../Assets/wallsac.png';
import savinginactive from '../../../Assets/wallsin.png';
import loanactive from '../../../Assets/loanac.png';
import loaninactive from '../../../Assets/loaninc.png';
import processingactive from '../../../Assets/processingac.png';
import processinginactive from '../../../Assets/processinginc.png';
import iconinactive from '../../../Assets/dshbrd-inactive.png';
import rprts from '../../../Assets/reportsicon.png';
import rprtsactive from '../../../Assets/reportsicon-active.png';
import stngs from '../../../Assets/settings-icon.png';
import stngsactive from '../../../Assets/settings-icon-active.png';
import usrnoti from '../../../Assets/notificatuin-bell.png';
import { Link, NavLink, useLocation, useNavigate } from 'react-router-dom';
import { useUser } from '../../../UserContext';
import Balance from '../../../Pages/Balance/Balance';
import { PiBuildingOfficeBold, PiShieldCheckBold } from 'react-icons/pi';
import { FaPowerOff } from 'react-icons/fa6';
import { FiMenu, FiX } from 'react-icons/fi';

import ChangePassword from '../../../Pages/ChangePassword/ChangePassword';
import UploadSalaryModal from '../../../Components/Modals/UploadSalaryModal';
import UploadAllowanceModal from '../../../Components/Modals/UploadAllowanceModal';
import InviteUserModal from '../../../Components/Modals/InviteUserModal';
import SavingsMod from './SavingsMod';
import LoanMod from './LoanMod';
import SavingsMod1 from './SavingsMod1';
import LoanMod1 from './LoanMod1';

const dropdownLabels = new Set([
  'Administration',
  'Admin',
  'Setup',
  'Members',
  'Savings',
  'Loans',
  'Processing',
  'Reports',
]);

export default function HeaderNav() {
  const location = useLocation();
  const navigate = useNavigate();
  const { user, logout } = useUser();

  const [openDropdown, setOpenDropdown] = useState(null);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [userDropdownOpen, setUserDropdownOpen] = useState(false);
  const dropdownRef = useRef(null);
  const userDropdownRef = useRef(null);
  const mobileDrawerRef = useRef(null);

  const [openSavingsModal, setOpenSavingsModal] = useState(false);
  const [openSavingsModal1, setOpenSavingsModal1] = useState(false);
  const [openLoanModal, setOpenLoanModal] = useState(false);
  const [openLoanModal1, setOpenLoanModal1] = useState(false);
  const [isBalanceOpen, setIsBalanceOpen] = useState(false);
  const [showChangePassword, setShowChangePassword] = useState(false);
  const [showUploadModal, setShowUploadModal] = useState(false);
  const [showUploadAllowanceModal, setShowUploadAllowanceModal] = useState(false);
  const [showInviteUserModal, setShowInviteUserModal] = useState(false);

  const baseNavItems = [
    { label: 'Home', path: '/dashboard', icon: iconinactive, activeIcon: icon },
    { label: 'Administration', path: '/administration', icon: iconinactive, activeIcon: icon },
    { label: 'Setup', path: '/setup', icon: stngs, activeIcon: stngsactive },
    { label: 'Members', path: '/members', icon: membericoninactive, activeIcon: membericonactive },
    { label: 'Savings', path: '/savings', icon: savinginactive, activeIcon: savingactive },
    { label: 'Loans', path: '/loans', icon: loaninactive, activeIcon: loanactive },
    { label: 'Processing', path: '/processing', icon: processinginactive, activeIcon: processingactive },
    { label: 'Reports', path: '/report', icon: rprts, activeIcon: rprtsactive },
  ];

  const navItems = user?.email === 'admin@brookes.com'
    ? [
        baseNavItems[0],
        { label: 'Admin', path: '/admin', icon: stngs, activeIcon: stngsactive },
        ...baseNavItems.slice(1),
      ]
    : baseNavItems;

  const isPathActive = (path) => {
    if (path === '/report') {
      return location.pathname === '/report' || location.pathname.startsWith('/reports/');
    }

    return location.pathname === path || location.pathname.startsWith(`${path}/`);
  };

  const closeNavigationMenus = () => {
    setOpenDropdown(null);
    setMobileMenuOpen(false);
  };

  const handleLogout = () => {
    logout();
    closeNavigationMenus();
    setUserDropdownOpen(false);
    navigate('/login');
  };

  useEffect(() => {
    const handleClickOutside = (e) => {
      const clickedInsideDropdown = dropdownRef.current?.contains(e.target);
      const clickedInsideDrawer = mobileDrawerRef.current?.contains(e.target);
      const clickedInsideUserDropdown = userDropdownRef.current?.contains(e.target);

      if (!clickedInsideDropdown && !clickedInsideDrawer) {
        setOpenDropdown(null);
      }

      if (!clickedInsideUserDropdown) {
        setUserDropdownOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  useEffect(() => {
    closeNavigationMenus();
  }, [location.pathname]);

  useEffect(() => {
    if (!mobileMenuOpen) return undefined;

    const previousOverflow = document.body.style.overflow;
    const handleKeyDown = (e) => {
      if (e.key === 'Escape') closeNavigationMenus();
    };

    document.body.style.overflow = 'hidden';
    document.addEventListener('keydown', handleKeyDown);

    return () => {
      document.body.style.overflow = previousOverflow;
      document.removeEventListener('keydown', handleKeyDown);
    };
  }, [mobileMenuOpen]);

  const dropdownLinkClass = ({ isActive }) =>
    `${classes.dropdownItem} ${isActive ? classes.activeDropdown : ''}`;

  const inactiveDropdownButtonClass = `${classes.dropdownItem} ${classes.dropdownButton}`;

  const renderPendingItem = (label) => (
    <button
      type="button"
      className={inactiveDropdownButtonClass}
      onClick={() => setOpenDropdown(null)}
    >
      {label}
    </button>
  );

  const renderDropdownContent = (label) => {
    switch (label) {
      case 'Administration':
        return (
          <>
            <NavLink to="/administration/manage-users" onClick={closeNavigationMenus} className={dropdownLinkClass}>
              Manage Users
            </NavLink>
            <NavLink to="/administration/manage-roles" onClick={closeNavigationMenus} className={dropdownLinkClass}>
              Manage Roles
            </NavLink>
            <NavLink to="/administration/manage-approvals" onClick={closeNavigationMenus} className={dropdownLinkClass}>
              Approval Levels
            </NavLink>
          </>
        );

      case 'Admin':
        return user?.email === 'admin@brookes.com' ? (
          <>
            <NavLink to="/admin/product-services" onClick={closeNavigationMenus} className={dropdownLinkClass}>
              Manage Companies
            </NavLink>
            <NavLink to="/settings/purchase-sales" onClick={closeNavigationMenus} className={dropdownLinkClass}>
              Manage Users
            </NavLink>
            <NavLink to="/admin/manage-industry" onClick={closeNavigationMenus} className={dropdownLinkClass}>
              Manage Chart of Account
            </NavLink>
          </>
        ) : null;

      case 'Setup':
        return (
          <>
            <NavLink to="/setup/savings-products" onClick={closeNavigationMenus} className={dropdownLinkClass}>
              Savings Products
            </NavLink>
            <NavLink to="/setup/loan-products" onClick={closeNavigationMenus} className={dropdownLinkClass}>
              Loan Products
            </NavLink>
          </>
        );

      case 'Members':
        return (
          <NavLink to="/members/members-database" onClick={closeNavigationMenus} className={dropdownLinkClass}>
            Members Database
          </NavLink>
        );

      case 'Savings':
        return (
          <>
            <NavLink to="/savings/savings-account" onClick={closeNavigationMenus} className={dropdownLinkClass}>
              Savings Account
            </NavLink>
            <NavLink to="/savings/member-savings" onClick={closeNavigationMenus} className={dropdownLinkClass}>
              Member Savings
            </NavLink>
            <NavLink to="/savings/member_savings_ledger" onClick={closeNavigationMenus} className={dropdownLinkClass}>
              Members&apos; Savings Ledger
            </NavLink>
            <NavLink to="/savings/withdrawals" onClick={closeNavigationMenus} className={dropdownLinkClass}>
              Savings Withdrawals
            </NavLink>
            <button
              type="button"
              className={inactiveDropdownButtonClass}
              onClick={() => {
                closeNavigationMenus();
                setOpenSavingsModal1(true);
              }}
            >
              Savings Data Migration
            </button>
          </>
        );

      case 'Processing':
        return (
          <>
            {/* <NavLink to="/processing/deductions/monthly-deduction" onClick={closeNavigationMenus} className={dropdownLinkClass}>
              Monthly Deduction
            </NavLink> */}
            <NavLink
              to="/processing/deductions/expected-monthly-deduction"
              onClick={closeNavigationMenus}
              className={dropdownLinkClass}
            >
              Expected Monthly Deduction Slip
            </NavLink>
            <NavLink
              to="/processing/deductions/actual-monthly-deduction"
              onClick={closeNavigationMenus}
              className={dropdownLinkClass}
            >
              Actual Monthly Deduction Slip
            </NavLink>
          </>
        );

      case 'Loans':
        return (
          <>
            <NavLink to="/loans/loan-applications" onClick={closeNavigationMenus} className={dropdownLinkClass}>
              Loan Applications
            </NavLink>
            <NavLink to="/loans/loan-approval" onClick={closeNavigationMenus} className={dropdownLinkClass}>
              Loan Approvals
            </NavLink>
            <NavLink to="/loans/disbursements" onClick={closeNavigationMenus} className={dropdownLinkClass}>
              Disbursements
            </NavLink>
            <NavLink to="/loans/member_loans_ledger" onClick={closeNavigationMenus} className={dropdownLinkClass}>
              Members&apos; Loans Ledger
            </NavLink>
            <NavLink to="/loans/loan-repayment" onClick={closeNavigationMenus} className={dropdownLinkClass}>
              Repayments
            </NavLink>
            <button
              type="button"
              className={inactiveDropdownButtonClass}
              onClick={() => {
                closeNavigationMenus();
                setOpenLoanModal1(true);
              }}
            >
              Loans Data Migration
            </button>
          </>
        );

      case 'Reports':
        return (
          <>
            <NavLink to="/reports/members-savings-balance" onClick={closeNavigationMenus} className={dropdownLinkClass}>
              Members&apos; Savings Balance
            </NavLink>
            <NavLink to="/reports/members-loan-balance" onClick={closeNavigationMenus} className={dropdownLinkClass}>
              Members&apos; Loan Balance
            </NavLink>
            <NavLink to="/reports/deduction-report" onClick={closeNavigationMenus} className={dropdownLinkClass}>
              Detailed Monthly Deduction Slip
            </NavLink>
            <NavLink to="/reports/summary-deduction-report" onClick={closeNavigationMenus} className={dropdownLinkClass}>
              Summary Monthly Deduction Slip
            </NavLink>
            {renderPendingItem('Payslip')}
          </>
        );

      default:
        return null;
    }
  };

  const renderNavigation = (isMobile = false) => (
    <div className={isMobile ? classes.drawerNavList : classes.headerNav}>
      {navItems.map((item) => {
        const isActive = isPathActive(item.path);
        const isDropdown = dropdownLabels.has(item.label);

        if (isDropdown) {
          const isOpen = openDropdown === item.label;

          return (
            <div
              key={item.label}
              className={`${classes.dshbrdnav} ${isActive ? classes.activeNav : ''} ${
                isMobile ? classes.drawerNavItem : ''
              }`}
            >
              <button
                type="button"
                className={classes.dshbrdnavMain}
                onClick={() => setOpenDropdown(isOpen ? null : item.label)}
                aria-expanded={isOpen}
              >
                <img
                  src={isActive ? item.activeIcon : item.icon}
                  alt={`${item.label} icon`}
                  className={classes.dshbrdicon}
                />
                <p className={isActive ? classes.activeText : ''}>{item.label}</p>
                {isMobile && <span className={classes.drawerChevron}>{isOpen ? '-' : '+'}</span>}
              </button>

              {isOpen && (
                <div
                  className={`${classes.dropdown} ${isMobile ? classes.drawerDropdown : ''}`}
                  ref={isMobile ? undefined : dropdownRef}
                >
                  {renderDropdownContent(item.label)}
                </div>
              )}
            </div>
          );
        }

        return (
          <Link
            to={item.path}
            key={item.label}
            className={`${classes.link} ${isMobile ? classes.drawerLink : ''}`}
            onClick={closeNavigationMenus}
          >
            <div
              className={`${classes.dshbrdnav} ${isActive ? classes.activeNav : ''} ${
                isMobile ? classes.drawerNavItem : ''
              }`}
            >
              <img
                src={isActive ? item.activeIcon : item.icon}
                alt={`${item.label} icon`}
                className={classes.dshbrdicon}
              />
              <p className={isActive ? classes.activeText : ''}>{item.label}</p>
            </div>
          </Link>
        );
      })}
    </div>
  );

  return (
    <div className={classes.entnav22}>
      <NavLink to="/dashboard" onClick={closeNavigationMenus}>
        <img src={logo} alt="Logo" className={classes.logo} />
      </NavLink>

      <div className={classes.desktopNav}>{renderNavigation(false)}</div>

      <div className={classes.headerActions}>
        <div className={classes.user}>
          <img src={usrnoti} className={classes.bellnoti} alt="Notification" />
          <div className={classes.userProfile} ref={userDropdownRef}>
            <button
              type="button"
              className={classes.userAvatar}
              onClick={() => setUserDropdownOpen(!userDropdownOpen)}
              aria-label="Open user menu"
              aria-expanded={userDropdownOpen}
            >
              <p className={classes.usrnm}>
                {user?.name ? user.name.split(' ').map((n) => n[0]).join('').toUpperCase() : 'U'}
              </p>
            </button>

            {userDropdownOpen && (
              <div className={classes.userDropdown}>
                <div className={classes.userInfo}>
                  <p className={classes.userName}>{user?.name || 'User'}</p>
                  <p className={classes.userEmail}>{user?.email || 'user@example.com'}</p>
                </div>
                <div className={classes.dropdownDivider}></div>

                <button
                  type="button"
                  className={`${classes.dropdownItemm} ${classes.dropdownItem}`}
                  onClick={() => {
                    navigate('/settings/add-company');
                    setUserDropdownOpen(false);
                  }}
                >
                  <PiBuildingOfficeBold size="18px" />
                  Add Company
                </button>
                <button
                  type="button"
                  className={`${classes.dropdownItemm} ${classes.dropdownItem}`}
                  onClick={() => {
                    setShowChangePassword(true);
                    setUserDropdownOpen(false);
                  }}
                >
                  <PiShieldCheckBold size="18px" />
                  Change Password
                </button>

                <button className={`${classes.dropdownItemm} ${classes.dropdownItem}`} onClick={handleLogout}>
                  <FaPowerOff size="16px" />
                  Logout
                </button>
              </div>
            )}
          </div>
        </div>

        <button
          type="button"
          className={classes.mobileMenuButton}
          onClick={() => setMobileMenuOpen(true)}
          aria-label="Open navigation menu"
          aria-expanded={mobileMenuOpen}
        >
          <FiMenu size="22px" />
        </button>
      </div>

      <button
        type="button"
        className={`${classes.mobileOverlay} ${mobileMenuOpen ? classes.mobileOverlayVisible : ''}`}
        onClick={closeNavigationMenus}
        aria-label="Close navigation menu"
      />

      <aside
        className={`${classes.mobileDrawer} ${mobileMenuOpen ? classes.mobileDrawerOpen : ''}`}
        ref={mobileDrawerRef}
        role="dialog"
        aria-modal="true"
        aria-label="Navigation menu"
      >
        <div className={classes.mobileDrawerHeader}>
          <img src={logo} alt="Logo" className={classes.drawerLogo} />
          <button
            type="button"
            className={classes.mobileCloseButton}
            onClick={closeNavigationMenus}
            aria-label="Close navigation menu"
          >
            <FiX size="22px" />
          </button>
        </div>

        <div className={classes.mobileDrawerBody}>{renderNavigation(true)}</div>
      </aside>

      <UploadSalaryModal isOpen={showUploadModal} onClose={() => setShowUploadModal(false)} />
      <UploadAllowanceModal
        isOpen={showUploadAllowanceModal}
        onClose={() => setShowUploadAllowanceModal(false)}
      />

      {showChangePassword && <ChangePassword onClose={() => setShowChangePassword(false)} />}
      <InviteUserModal show={showInviteUserModal} onHide={() => setShowInviteUserModal(false)} />
      <Balance isOpen={isBalanceOpen} onClose={() => setIsBalanceOpen(false)} />

      <SavingsMod
        isOpen={openSavingsModal}
        onClose={() => setOpenSavingsModal(false)}
        onSuccess={() => {
          setOpenSavingsModal(false);
        }}
      />
      <SavingsMod1
        isOpen={openSavingsModal1}
        onClose={() => setOpenSavingsModal1(false)}
        onUploadDocument={() => {
          setOpenSavingsModal1(false);
          setOpenSavingsModal(true);
        }}
      />

      <LoanMod1
        isOpen={openLoanModal1}
        onClose={() => setOpenLoanModal1(false)}
        onUploadDocument={() => {
          setOpenLoanModal1(false);
          setOpenLoanModal(true);
        }}
      />
      <LoanMod
        isOpen={openLoanModal}
        onClose={() => setOpenLoanModal(false)}
        onSuccess={() => {
          setOpenLoanModal(false);
        }}
      />
    </div>
  );
}
